module.exports = __webpack_public_path__ + "img/template-01.54fcec2f.jpg";